import axios from 'axios';
import Globals from '../Globals';
import { getLogModel } from '../Functions';
import LoggingService from './LoggingService';

class VehicleDetailService {
    base_url = Globals.BFF_PATH.BASE_URL + Globals.BFF_PATH.VEHICLE.BASE_PATH;

    getDetails = async (token, vehicleId, type) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };

        const data = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify({
                VehicleId: vehicleId,
                ValorationType: type,
            }),
        };

        return await axios
            .post(this.base_url + Globals.BFF_PATH.VEHICLE.DETAIL, data, config)
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };
    getExpertisesList = async (token, VIN) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };

        const data = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify({
                VIN: VIN,
            }),
        };

        return await axios
            .post(
                this.base_url + Globals.BFF_PATH.VEHICLE.GET_EXPERTISE_LIST,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data;
            })
            .catch(function (error) {
                //Error(error);
            });
    };

    getExpertiseData = async (token, ExpertiseData) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };

        const data = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify({
                ExpertiseId: ExpertiseData.ExpertiseId,
                Plate: ExpertiseData.Plate,
                ProfileId: ExpertiseData.ProfileId,
                OnlyHtml: ExpertiseData.OnlyHtml,
            }),
        };
        return await axios
            .post(
                this.base_url + Globals.BFF_PATH.VEHICLE.GET_EXPERTISE_DATA,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                }
                return response.data;
            })
            .catch(function (error) {
                //Error(error);
            });
    };

    getVehicleAccidents = async (token, Plate, IdVehicle) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };

        const data = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify({
                Plate: Plate,
                IdVehicle: IdVehicle,
            }),
        };

        return await axios
            .post(
                this.base_url + Globals.BFF_PATH.VEHICLE.GET_VEHICLE_ACCIDENTS,
                data,
                config
            )
            .then(response => {
                if (response?.data?.body) {
                    const res = JSON.parse(response.data.body).Result;
                    return res && JSON.parse(res);
                }
            })
            .catch(function (error) {
                //Error(error);
            });
    };

    getVehicleMaintenance = async (token, body) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };

        const data = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(body),
        };

        return await axios
            .post(
                this.base_url + Globals.BFF_PATH.VEHICLE.GET_MAINTENANCE_LIST,
                data,
                config
            )
            .then(response => {
                if (response?.data?.body) {
                    const res = JSON.parse(response.data.body).Result;
                    return res && JSON.parse(res);
                }
            })
            .catch(function (error) {
                //Error(error);
            });
    };

    getVehicleMaintenanceDetails = async (token, body) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };

        const data = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(body),
        };

        return await axios
            .post(
                this.base_url +
                    Globals.BFF_PATH.VEHICLE.GET_MAINTENTANCE_DETAILS_LIST,
                data,
                config
            )
            .then(response => {
                if (response?.data?.body) {
                    const res = JSON.parse(response.data.body).Result;
                    return res && JSON.parse(res);
                }
            })
            .catch(function (error) {
                //Error(error);
            });
    };
}

export default VehicleDetailService;
